import * as React from "react";

const BolDescription: React.FC = () => {
  return (
    <div className="mainheader">
      <h1 style={{ color: "#77CC00" }}>Upload Beneficial Owner List</h1>
      <p style={{ fontSize: "11px" }}>
        BO lists are submitted as part of a simplified withholding, or
        relief-at-source, tax procedure.
        <br /> <br />
        This facility allows you to provide us with the details of the
        beneficial owners on behalf of whom you hold equities, bonds or other
        types of securities so that you can benefit from a reduced withholding
        tax rate.
        <br /> <br />
        This service is restricted to customers only and requires to be logged
        in as a Premium User.
        <br /> <br />
        To login, please use the link provided on the right hand side of this
        page (Login area).
        <br /> <br />
        Customers can use the BO list upload service for several markets. Their
        list is available
        <a href="http://www.clearstream.com/clearstream-en/securities-services/asset-services/tax-and-certification/upload-bo-list">
          {" "}
          here
        </a>
        .
      </p>
    </div>
  );
};

export default BolDescription;
